<template>
  <div class="row">
    <div class="col">
      <div class="card card-modern">
        <div class="card-body">
          <div class="datatables-header-footer-wrapper">
            <div class="datatable-header">
              <div class="row mb-3">
                <div class="col-8 d-flex mb-3 mb-lg-0 d-flex align-items-center">
                  <treeselect
                    v-model="b2bOrb2c"
                    class="w-25 mx-1 form-control form-control-modern"
                    :options="b2bOrb2cOptions"
                    placeholder="B2B/B2C"
                  />
                </div>
                <div class="col-4 col-lg-auto ps-lg-1 mb-3 mb-lg-0">
                  <div class="d-flex align-items-lg-center flex-column flex-lg-row">
                    <select class="form-control select-style-1 results-per-page" name="results-per-page"
                      v-model="searchConfig.pageSize" @change="changePageSize(searchConfig.pageSize)">
                      <option :value="page" v-for="page in pageSizeList" :key="page">
                        {{ page }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-lg-auto ps-lg-1">
                  <div class="search search-style-1 search-style-1-lg mx-lg-auto">
                    <div class="input-group">
                      <input type="text" class="search-term form-control" placeholder="Search" v-model="searchField"
                        @input="debounceInput" />
                      <button class="btn btn-default" type="submit">
                        <i class="bx bx-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="dataTables_wrapper dt-bootstrap5 no-footer" v-if="list.length > 0">
              <div class="row justify-content-between">
                <div class="col-auto"></div>
                <div class="col-auto"></div>
              </div>
              <div class="table-responsive">
                <table class="table table-ecommerce-simple table-striped mb-0 dataTable no-footer">
                  <thead>
                    <tr role="row">
                      <th class="sorting_disabled">
                        <input type="checkbox" class="select-all checkbox-style-1 p-relative top-2"
                          v-model="selectAll" />
                      </th>
                      <th class="sorting">Rbr</th>
                      <th class="sorting">Artikal</th>
                      <th class="sorting">Šifra artikla</th>
                      <th class="sorting">Status</th>
                      <th class="sorting">Zatražio</th>
                      <th class="sorting">Komentar</th>
                      <th class="sorting">Datum kreiranja</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr role="row" v-for="(item, index) in list" :key="item.id" @click="openDetails(item.id)"
                      :class="{ odd: index % 2 === 0, even: index % 2 !== 0 }">
                      <td width="30">
                        <input type="checkbox" class="checkbox-style-1 p-relative top-2" :value="item.id"
                          v-model="selected" @click.stop />
                      </td>
                      <td>
                        <strong>{{
                        (pager.currentPage - 1) * searchConfig.pageSize +
                        index +
                        1
                      }}</strong>
                      </td>
                      <td>
                        <strong>{{ item.article }}</strong>
                      </td>
                      <td>{{ item.code }}</td>
                      <td>
                        <div class="badge" :class="{
                        'badge-success': item.status,
                        'badge-danger': !item.status,
                      }">
                          {{
                        item.status ? 'Procesuirano' : 'Nije procesuirano'
                      }}
                        </div>
                      </td>
                      <td>{{ item.requestedBy }} - {{ item.email }}</td>
                      <td>{{ item.comment }}</td>
                      <td>{{ formatDate(item.createdDate) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else>
              <div class="alert alert-info" role="alert">
                {{ translations.noRecords }}
                <a class="alert-link" @click.prevent="resetFilters">{{
                        translations.resetFilters
                      }}</a>.
              </div>
            </div>
            <hr class="solid mt-5 opacity-4" />

            <div class="datatable-footer">
              <div class="row align-items-end justify-content-start mt-3">
                <div class="col-lg-2 col-md-6">
                  <select class="form-control select-style-1 bulk-action" name="bulk-action" v-model="bulkAction">
                    <option value="bulkAction">Bulk Actions</option>
                    <option value="delete">Delete</option>
                  </select>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12">
                  <div class="col-lg-9 col-md-12 col-sm-12">
                    <button type="button" data-bs-toggle="modal" data-bs-target="#delete-modal"
                      class="text-color-dark btn btn-light border btn-px-4 py-3 col-md-12 col-sm-12 d-flex align-items-center font-weight-semibold line-height-1">
                      {{ translations.apply }}
                    </button>
                  </div>
                </div>
                <div class="row row-gutter-sm justify-content-between mt-4">
                  <pagination
                    :action="actionName"
                    :pagination-props="paginationProps"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal id="delete-modal">
      <h5 slot="header">
        <strong>{{ translations.deleteSelected }}</strong>
      </h5>
      <div slot="body">
        <span v-html="articleModalText"> </span>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button type="button" class="btn btn-primary px-4 mx-2" @click.prevent.stop="handleBulkAction"
              data-bs-dismiss="modal">
              {{ translations.yes }}
            </button>
            <button type="button" class="btn btn-default px-4" data-bs-dismiss="modal">
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- end: page -->
  </div>
</template>
<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { pager, translations } from '@/mixins';
import Pagination from '@/components/shared/Pagination.vue';
import Modal from '../shared/modal/Modal.vue';

export default {
  name: 'OutOfStockArticle',
  mixins: [pager, translations],
  components: {
    Treeselect,
    Pagination,
    Modal,
  },
  data() {
    const { query } = this.$route;

    return {
      actionName: 'getOutOfStockArticles',
      deleteActionName: 'deleteOutOfStockArticles',
      bulkActionName: 'deleteOutOfStockArticles',
      status: null,
      b2bOrb2c: query?.b2b ? 'b2b' : query?.b2c ? 'b2c' : null,
    };
  },
  computed: {
    list() {
      return this.$store.getters.getOutOfStockArticles;
    },
    articleModalText() {
      return this.translations.areYouSureSelected;
    },
    b2bOrb2cOptions() {
      return [
        { id: 'b2b', label: 'B2B' },
        { id: 'b2c', label: 'B2C' },
        { id: 'all', label: 'Sve' },
      ];
    },
    paginationProps() {
      return {
        ...this.searchConfig,
        status: this.status,
        b2b: this.b2bOrb2c === 'b2b' ? true : null,
        b2c: this.b2bOrb2c === 'b2c' ? true : null,
      };
    },
  },
  mounted() {
    this.$store.dispatch(this.actionName, this.paginationProps);
  },
  methods: {
    openDetails(id) {
      this.$router.push({ name: 'EditOutOfStockArticle', params: { id: id } });
    },
    getOutOfStockArticles() {
      this.$store.dispatch(this.actionName, {
        ...this.searchConfig,
        ...this.paginationProps,
        page: 1,
      });

      this.$router
        .push({
          query: {
            ...this.paginationProps,
            page: 1,
          },
        })
        .catch(() => {});
    },
  },
  watch: {
    b2bOrb2c() {
      this.getOutOfStockArticles();
    },
  },
};
</script>
<style lang="scss" scoped>
.sorting {
  cursor: pointer;
}

tbody tr {
  cursor: pointer;
}
</style>

<style>
.vue-treeselect__placeholder {
  color: #000;
}

.form-control.form-control-modern.vue-treeselect.vue-treeselect--open-below.vue-treeselect--searchable.vue-treeselect--single.w-25 {
  height: 46px;
}

.vue-treeselect__control {
  border: none;
  background: none;
}
</style>